import React from 'react';
import { useState, useEffect, Fragment } from 'react';
import {
  Badge,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button, Modal, Col, Spinner, ModalFooter, ModalBody,
  FormGroup, Label, Input, NavLink
} from "reactstrap";
import { Form, Field } from "react-final-form";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import dataProvider from "dataProvider";
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";
import auth from "authProvider";


const Expire = (props) => {
  const [tenants, setTenants] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [pos, setPos] = useState(false);
  const [flag, setFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState(false);
  const [endDate_update, setEndDate_update] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);
  const [reload, setReload] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState({ visible: false, id: null, index: null });

  const onLogout = () => {
    auth.logout();
    history.push("/")
  }
  const history = useHistory();

  const handleClickOpen = (index) => {
    setPos(index)
    setEndDate_update(new Date(tenants[index].contract_ended));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    dataProvider.getList('locations', { params: { pagination: { page: 1, perPage: 20 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setLocations(data); })

    dataProvider.getList('tenants/expiring', { params: { pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'contract_ended' }, filter: {} }, })
      .then(({ data }) => {
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        if (data && data.length > 0) {
          let newList = data.filter(item => {
            if (item.contract_ended !== null) { return item }
          })
          setTenants(newList);
        }
      })
  }, [props, reload]);

  const removeData = (id, index) => {
    dataProvider.delete('tenants', { id: id });
    let tenantArr = tenants;
    tenantArr.splice(index, 1);
    setTenants(tenantArr);
    setFlag(!flag)
    setConfirmOpen({ visible: false, id: null, index: null });
  }
  const Closeconfirm = () => {
    setConfirmOpen({ visible: false, id: null, index: null });
  };
  const onSubmit_update = (values, id) => {
    setOpen(false);
    dataProvider.update('tenants', { id: tenants[pos].id, params: { ...values, contract_ended: endDate_update } })
      .then(({ data }) => {
        history.push("/tenants/expire");
      })
      .catch(error => {
        setLoading(false)
        alert(error.message)
      });

  };
  const onPagination = (i) => {
    let newPage = page + i;
    if (newPage == 0) {
      return;
    }
    else if (i === 1 && !more) {
      return;
    }
    setPage(newPage);
    setReload(!reload);
  }

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <Row style={{ color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }}>
              <h2 className="mb-0" style={{ color: 'white', alignContent: 'flex-start', fontSize: '1.5rem' }}>EXPIRING SOON</h2>
            </Row>
          </div>
        </Container>
      </div>
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }} >
                <div style={{ alignContent: 'flex-start' }}>
                  <h2>Users</h2>
                </div>
                <div style={{ alignContent: 'flex-end' }}>
                  {page > 1 || page !== 1 ? <Button onClick={() => onPagination(-1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', height: '2.5rem', padding: '0px', color: 'rgb(66 54 47)', width: '5rem', margin: '0px', borderColor: 'rgb(144 151 153)' }} >
                    <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="prev" />PREV</Button>
                    : <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: '#ccc' }} >
                      <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="prev" />PREV</Button>}
                  {more ? <Button onClick={() => onPagination(1)} style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: 'rgb(66 54 47)', width: '5rem', borderColor: 'rgb(144 151 153)' }} > NEXT
                    <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="next" /></Button> :
                    <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: '#ccc' }} > NEXT
                      <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="next" /></Button>}
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr style={{ textAlign: 'center' }}>
                    <th scope="col">
                      <FormGroup check style={{ paddingBottom: '20px' }}>
                        <Input type="checkbox" />{' '}
                      </FormGroup>
                    </th>
                    <th scope="col">USER</th>
                    <th scope="col">EMAIL</th>
                    <th scope="col">USERNAME</th>
                    <th scope="col">PHONE NUMBER</th>
                    <th scope="col" >EXPIRY</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {tenants && tenants.length > 0 && (
                    tenants.map((item, index) => (
                      <tr style={{ textAlign: 'center' }}>
                        <th>
                          <FormGroup check style={{ paddingBottom: '20px' }}>
                            <Input type="checkbox" />{' '}
                          </FormGroup>
                        </th>
                        <td style={{ color: '#12ACF6' }}>{item.fullname}</td>
                        <td>{item.email}</td>
                        <td>{item.username}</td>
                        <td>{item.mobile}</td>
                        {/* <td>{item.contractEnd && (<Dateshow date={item.contractEnd} />)}</td> */}
                        <td style={{ color: 'red' }}>{item.contractEnd}</td>
                        <td style={{ flexDirection: 'row', display: 'flex' }}>
                          <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => handleClickOpen(index)} ><IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="edit" /></Button>
                          <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => setConfirmOpen({ visible: true, id: item.id, index: index })}> <IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="delete" /></Button>
                          {/* <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => removeData(item.id, index)}> <IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="delete" /></Button> */}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              <Modal isOpen={confirmOpen.visible} size="sm">
                <div className="modal-header"></div>
                <ModalBody style={{ color: 'red', padding: 0, paddingLeft: 20 }}>DO YOU WANT DELETE THIS  ?</ModalBody>
                <ModalFooter >
                  <Button onClick={Closeconfirm} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    NO
                  </Button>
                  <Button onClick={() => removeData(confirmOpen.id, confirmOpen.index)} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    YES
                  </Button>
                </ModalFooter>
              </Modal>
            </Card>
          </div>
        </Row>
      </Container>
      <Modal
        className="modal-dialog-centered"
        isOpen={open}
        size="lg" style={{ maxWidth: '50rem', width: '100%' }}
      // onClick={handleClose}
      >
        <div style={{ backgroundColor: 'rgb(193 193 125)', width: '30px', height: '30px', position: 'absolute', right: '-10px', borderRadius: '50%', top: '-10px' }}>
          <IcomoonReact iconSet={iconSet} onClick={handleClose} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
        </div>
        <div className="modal-header" style={{ backgroundColor: 'rgb(9 87 124)' }} >
          <h3 style={{ marginLeft: 20, color: 'white' }}>EDIT TENANT</h3>
        </div>
        <div>
          <Form
            onSubmit={onSubmit_update}
            validate={values => {
              const errors = {};
              function validateEmail(email) {
                var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
              }
              function validatePhone(phone) {
                var ph = /^(\d{8}(\,\d{8}){0,2})$/;
                return ph.test(String(phone).toLowerCase());
              }
              if (!values.fullname) {
                errors.fullname = "required";
              }
              if (!values.phone) {
                errors.phone = "Required";
              } else if (!validatePhone(values.phone)) {
                errors.phone = "Enter a valid phonenumber";
              }
              if (!values.email) {
                errors.email = "required";
              } else if (!validateEmail(values.email)) {
                errors.email = "Enter a valid email address";
              }
              if (!values.username) {
                errors.username = "required";
              }
              return errors;
            }}
            render={({ handleSubmit
            }) => (
              <form onSubmit={handleSubmit} style={{ padding: '20px' }}>
                <div className="pl-lg-4">
                  <Row>
                    <Col lg="4">
                      <FormGroup>
                        <Label for="name" style={{ fontSize: ' 0.8125rem' }}>Full Name</Label>
                        <Field name="fullname" initialValue={tenants[pos].fullname ? tenants[pos].fullname : null}>
                          {({ input, meta }) => (
                            <div>
                              <Input
                                {...input}
                                type="text"
                                name="fullname"
                                placeholder="Enter Tenant FullName"
                                style={{ color: 'black' }}
                                invalid={meta.error && meta.touched}
                              />
                              {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                    <Col lg="4">
                      <FormGroup>
                        <Label style={{ fontSize: ' 0.8125rem' }} for="phone">Phone Number</Label>
                        <Field name="phone" initialValue={tenants[pos].mobile ? tenants[pos].mobile : null}>
                          {({ input, meta }) => (
                            <div>
                              <Input
                                {...input}
                                type="text"
                                name="phone"
                                style={{ color: 'black' }}
                                placeholder="Enter Phone Number"
                                invalid={meta.error && meta.touched}
                              />
                              {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                    <Col lg="4">
                      <FormGroup>
                        <Label style={{ fontSize: ' 0.8125rem' }} for="email">E-mail</Label>
                        <Field name="email" initialValue={tenants[pos].email ? tenants[pos].email : null}>
                          {({ input, meta }) => (
                            <div>
                              <Input
                                {...input}
                                type="email"
                                style={{ color: 'black' }}
                                placeholder="Enter email address"
                                invalid={meta.error && meta.touched}
                              />
                              {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="4">
                      <FormGroup >
                        <Label style={{ fontSize: ' 0.8125rem' }} for="role">Contract End Date</Label>
                        <Field name="contract_ended" >
                          {({ input, meta, value }) => (
                            <div>
                              <DatePicker
                                value={endDate_update}
                                selected={endDate_update}
                                minDate={new Date()}
                                style={{ padding: 20 }}
                                onChange={(date) => setEndDate_update(date)}
                                dateFormat='dd-MM-yyyy'
                                //required={true}
                                isClearable
                                className="datePicker"
                              />
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                    <Col lg="4">
                      <FormGroup>
                        <Label style={{ fontSize: ' 0.8125rem' }} for="username">User Name</Label>
                        <Field name="username" initialValue={tenants[pos].username ? tenants[pos].username : null}>
                          {({ input, meta }) => (
                            <div>
                              <Input
                                {...input}
                                type="text"
                                style={{ color: 'black' }}
                                name="username"
                                placeholder="Enter User Name"
                                invalid={meta.error && meta.touched}
                              />
                              {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
                <Col md="4" >
                  <div style={{ paddingBottom: '30px', padding: 10 }}>
                    <Button color={'white'} type="submit" style={{ backgroundColor: '#09577C', color: 'white', width: '80%', borderRadius: '10px', flex: 1, border: 0 }} >
                      SAVE CHANGES</Button>{' '}
                  </div>
                </Col>
              </form>
            )}
          />
        </div>
      </Modal>
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Expire;
